
document.addEventListener('DOMContentLoaded', ()=> {
    const pdpDeliPopup=document.getElementById('PDP-delivery__popUp');
    const pdpDelivery=document.getElementById('PDP-delivery__delivery');
    const pdpDeliPopupClose=document.getElementById('PDP-delivery__close');
    const pdpShiPopup=document.getElementById('PDP-shipping__popUp');
    const pdpShipping=document.getElementById('PDP-delivery__shipping');
    const pdpShiPopupClose=document.getElementById('PDP-shipping__close'); // Open the pop up
    if (pdpDelivery) {
      pdpDelivery.addEventListener('click', ()=> {
        console.log('PDP Delivery button clicked');
        pdpDeliPopup.classList.remove('PDP-el-hide');
        pdpDeliPopup.animate( [ {
          opacity: 0
        }
        , {
          opacity: 1
        }
        ], {
          duration: 500, fill: 'forwards'
        }
        );
      }
      );
    }
    if (pdpShipping) {
      pdpShipping.addEventListener('click', ()=> {
        pdpShiPopup.classList.remove('PDP-el-hide');
        pdpShiPopup.animate( [ {
          opacity: 0
        }
        , {
          opacity: 1
        }
        ], {
          duration: 500, fill: 'forwards'
        }
        );
      }
      );
    } // Close the Pop up
    if (pdpDeliPopupClose) {
      pdpDeliPopupClose.addEventListener('click', ()=> {
        pdpDeliPopup.classList.add('PDP-el-hide');
      }
      );
    }
    if (pdpShiPopupClose) {
      pdpShiPopupClose.addEventListener('click', ()=> {
        pdpShiPopup.classList.add('PDP-el-hide');
      }
      );
    }
  }
  );
  //product video
  document.addEventListener('DOMContentLoaded', ()=> {
    const pdpVideo=document.getElementById('PDP-video');
    const pdpVideoPopup=document.getElementById('PDP-video__popUp');
    const pdpVideoPopupClose=document.getElementById('PDP-video__close');
    const pdpVideoIframe=document.getElementById('PDP-video-pr__iframe');
    if (pdpVideo) {
      pdpVideo.addEventListener('click', ()=> {
        pdpVideoPopup.classList.remove('PDP-el-hide');
        pdpVideoPopup.animate( [ {
          opacity: 0
        }
        , {
          opacity: 1
        }
        ], {
          duration: 500, fill: 'forwards'
        }
        );
      }
      );
    }
    if (pdpVideoPopupClose) {
      pdpVideoPopupClose.addEventListener('click', ()=> {
        pdpVideoPopup.classList.add('PDP-el-hide'); // Stop the video playback
        const iframeSrc=pdpVideoIframe.src;
        pdpVideoIframe.src='';
        pdpVideoIframe.src=iframeSrc;
      }
      );
    }
  }
  );
  //assembly video
  document.addEventListener('DOMContentLoaded', ()=> {
    const pdpVideoAS=document.getElementById('PDP-video__as');
    const pdpVideoPopupAS=document.getElementById('PDP-video__popUp__as');
    const pdpVideoPopupCloseAS=document.getElementById('PDP-video__close__as');
    const pdpVideoIframeAS=document.getElementById('PDP-video-as__iframe');
    if (pdpVideoAS) {
      pdpVideoAS.addEventListener('click', ()=> {
        pdpVideoPopupAS.classList.remove('PDP-el-hide');
        pdpVideoPopupAS.animate( [ {
          opacity: 0
        }
        , {
          opacity: 1
        }
        ], {
          duration: 500, fill: 'forwards'
        }
        );
      }
      );
    }
    if (pdpVideoPopupCloseAS) {
      pdpVideoPopupCloseAS.addEventListener('click', ()=> {
        pdpVideoPopupAS.classList.add('PDP-el-hide'); // Stop the video playback
        const iframeSrcAS=pdpVideoIframeAS.src;
        pdpVideoIframeAS.src='';
        pdpVideoIframeAS.src=iframeSrcAS;
      }
      );
    }
  }
  );